import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { loaderHandler } from "src/lib/loaderHandler";
import { CoachLibraryProgramsPage } from "src/pages/CoachLibraryProgramsPage";
import { createPersonalLibraryProgramsRepository } from "src/repositories/programs/createPersonalLibraryProgramsRepository";

export const PROGRAMS_DEFAULT_PAGE_SIZE = 10;

const searchSchema = z.object({
  q: z.string().optional(),
  p: z.coerce.number().optional(),
  ps: z.coerce.number().optional(),
});

export const Route = createFileRoute("/_auth/_coach/library/programs/")({
  component: RouteComponent,
  validateSearch: searchSchema,
  ssr: true,
  loaderDeps: ({ search }) => {
    return search;
  },
  async loader({ context, deps }) {
    return await loaderHandler(async () => {
      const pageSize = deps.ps || PROGRAMS_DEFAULT_PAGE_SIZE;
      const programsRepository = createPersonalLibraryProgramsRepository();
      const programs = await context.queryClient.query({
        ...programsRepository.listOptions({
          query: deps.q || "",
          pageIndex: deps.p || 0,
          pageSize,
        }),
        staleTime: "static",
      });

      return {
        data: {
          programs,
          pageSize,
        },
      };
    });
  },
});

function RouteComponent() {
  return <CoachLibraryProgramsPage />;
}
